import * as yup from 'yup';

type TBusinessDetailsFormValidation = {
    monthlyTurnoverOptional?: boolean;
    vatOptional?: boolean;
    soleTrader?: boolean;
};

/**
 * Business details schema for minimum data requirements and form validation.
 * @returns yup object schema for validation
 */
export const businessDetailsFormValidation = ({
    monthlyTurnoverOptional,
    vatOptional,
    soleTrader
}: TBusinessDetailsFormValidation): yup.Schema => {
    return yup.object().shape({
        annual_turnover: yup
            .number()
            .required('Please enter your estimated turnover')
            .typeError('Please enter your estimated turnover'),
        monthly_turnover: monthlyTurnoverOptional
            ? yup
                  .number()
                  .required('Please enter your estimated turnover')
                  .typeError('Please enter your estimated turnover')
            : yup.number().typeError('Please enter your estimated turnover'),
        registered: yup.object().shape({
            mm: yup.string().required('Please enter both a month and year'),
            yy: yup
                .string()
                .required('Please enter both a month and year')
                .min(4, 'Minimum 4')
                .max(4, 'Maximum 4')
                .matches(
                    /^(18[0-9]\d|19[0-9]\d|20[0-2]\d)$/,
                    'Please enter both a month and year'
                )
        }),
        vat_registered_status: vatOptional
            ? yup
                  .boolean()
                  .transform((value, originalValue) => {
                      if (originalValue === '') return null;

                      return value;
                  })
                  .nullable()
            : yup
                  .boolean()
                  .transform((value, originalValue) => {
                      if (originalValue === '') return null;

                      return value;
                  })
                  .nullable()
                  .required('Please select your vat status'),
        company_name: soleTrader
            ? yup.string().optional()
            : yup.string().required('Please enter your company name'),
        company_number: soleTrader
            ? yup.string().optional()
            : yup
                  .string()
                  .required('Please enter a valid company number')
                  .min(8, 'Your company number is not valid'),
        website: yup
            .string()
            .matches(
                /^$|((http|https)\:\/\/)?[a-zA-Z0-9\.\/\?\:@\-_=#]+\.([a-zA-Z0-9\&\.\/\?\:@\-_=#])*/,
                'Enter a valid website address (e.g. www.example.com)'
            ),
        annual_business_profit: soleTrader
            ? yup
                  .number()
                  .required('enterProfitError')
                  .typeError('enterProfitError')
            : yup
                  .number()
                  .transform((value) => (Number.isNaN(value) ? null : value))
                  .nullable(),
        industry: soleTrader
            ? yup.string().required('selectIndustryError')
            : yup.string().optional(),
        trading_as: yup.string().optional()
    });
};
